
import { Component, Vue, Watch } from "vue-property-decorator";
import QuestionCard from "@/components/question/QuestionCard.vue";
import { QuestionObject } from "@/lib/model/question/question"; //questionlist Model
import { Question } from "@/lib/model/question/question"; //question Model
import QueryListParams from "@/lib/form/question/QueryListForm"; //列表请求参数
import QuestionEdit from "./question-edit.vue"; //编辑弹窗
import request from "@/lib/request/request";
import Breadcrumb from "@/components/layout/breadcrumb.vue";
import Loading from "../../components/loading.vue";

@Component({
  components: {
    QuestionCard,
    QuestionEdit,
    Breadcrumb,
    Loading
  }
})
export default class QuestionStore extends Vue {
  //解决ts不识别refs的方法
  $refs!: { edit: HTMLFormElement };
  placeholder = "关键字";
  searchOptions = [
    { label: "题干关键字", value: "descLike" },
    { label: "题目编号", value: "companyIndex" },
    { label: "备注", value: "remark" }
  ];
  searchQuestionType = 0;
  searchAiType = "";
  searchType = "descLike";
  searchText = "";
  questionList: Question[] = [];
  selectedQIdList: number[] = []; //已选中题目id；Question Q
  page = 1;
  total = 0;
  canSelectFlag = false; //题卡是否可选 ——在题库的列表页不可选题
  url = {
    AiList: "aiExam/question/listFeatures",
    del: "aiExam/question/delete"
  };
  AiList = [];
  paperId = 0; //试卷Id 也是examId
  from = ""; //来自编辑or新建
  showEditModel = false;
  dataReady = false;
  @Watch("searchType", { immediate: true, deep: true })
  onCh(n: any, o: any) {
    this.placeholder =
      n === "descLike" ? "关键字" : n === "companyIndex" ? "编号" : "备注";
  }
  //离开选题页面时 不可选题
  @Watch("$route", { immediate: true, deep: true })
  onRouter(n: any, o: any) {
    if (n.query.state !== "select") {
      this.canSelectFlag = false;
    }
  }
  mounted() {
    //跳转入口
    if (this.$route?.query?.state === "select") {
      this.paperId = Number(this.$route?.query?.paperId) || 0;
      this.canSelectFlag = true;
      //已选中题目id
      this.selectedQIdList = this.$route.query.selectedIdList
        ? String(this.$route.query.selectedIdList)
            .split(",")
            .map(Number)
        : [];
      this.from = String(this.$route?.query?.from);
    }

    this.getList();
    this.sendRequest(this.url.AiList).then((res: any) => {
      this.AiList = res?.aiDimension; //AI维度
    });
  }

  //获取列表
  getList() {
    const params = new QueryListParams();
    params.page = this.page;
    params.type = this.searchQuestionType;
    params.aiDimension = this.searchAiType;
    params[this.searchType] = String(this.searchText);
    QuestionObject.get(params).then(res => {
      this.questionList = res.list;
      this.total = res.count;
      this.dataReady = true;
    });
  }
  //搜索
  searchList() {
    this.page = 1;
    this.getList();
  }
  //新增、编辑
  openQuestion(question?: any) {
    this.$refs.edit.open(question);
  }
  //删题
  del(question: any) {
    this.sendRequest(this.url.del, { questionId: question.questionId }).then(
      () => {
        this.$message.success("删除成功！");
        this.getList();
      }
    );
  }
  //选题
  selectCard(card: Question) {
    const index = this.selectedQIdList.indexOf(card.questionId);
    if (index === -1) {
      this.selectedQIdList.push(card.questionId);
    } else {
      this.selectedQIdList.splice(index, 1);
    }
  }
  //提交已选题目
  submitSelected() {
    this.sendRequest("aiExam/examQuestions/set", {
      examId: this.paperId,
      questionIdList: this.selectedQIdList
    }).then(() => {
      this.$message.success("保存成功！");
      //跳转
      this.$router.push(
        `/question-paper?paperId=${this.paperId}&from=${this.from}`
      );
    });
  }

  //请求接口统一处理
  sendRequest(url: any, params = {}, method = "post") {
    return new Promise(function(resolve, reject) {
      request[method](url, params).then((resp: { data: any }) => {
        if (resp.data.code === 0) {
          resolve(resp.data.data);
        } else {
          reject(resp.data.message);
        }
      });
    }).catch(e => {
      console.log(e);
    });
  }
  changeRadio(e: string) {
    // this.radio = e;
  }
}
